module.exports = __webpack_public_path__ + "img/logo-kleinanzeigen.37bbd6c3.png";